define('models/shared/qanda/choice',["backbone"
], function (Backbone) {

    var Choice = Backbone.Model.extend({
        url: function () {
        },
        initialize: function (options) {

            options || (options = {});
            this.choiceID = options.CID;
            this.choiceText = options.CT;
        },
        parse: function (data) {

            var response = {};
            response.choiceID = data.CID;
            response.choiceText = data.CT;
            return response;
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};
            var data = {};
            data.CID = this.choiceID ;
            data.CT = this.choiceText;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return Choice;
});

